import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/Tracking.css";
import heroImg from "../../assets/truck.png";
import ctaImg from "../../assets/trackingpage.png";

const Tracking = () => {
  const [awb, setAwb] = useState("");
  const navigate = useNavigate();

  const handleTrack = () => {
    if (!awb.trim()) {
      alert("Please enter tracking number");
      return;
    }

    navigate("/tracking-box", {
      state: {
        awbArray: [awb],
      },
    });
  };

  return (
    <div className="tracking-page">
      {/* HERO SECTION */}
      <div className="tracking-hero" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="tracking-overlay">
          <div className="tracking-content">
            <h1>Track Your Shipment</h1>
            <p>Easily track your shipment in real-time</p>

            <div className="tracking-input">
              <input
                type="text"
                placeholder="Enter your tracking number"
                value={awb}
                onChange={(e) => setAwb(e.target.value)}
              />
              <button onClick={handleTrack}>Track</button>
            </div>
          </div>
        </div>
      </div>

      {/* STATUS */}
      <div className="tracking-status">
        <div className="status-box">📦 Shipment Accepted</div>
        <div className="status-box">🚚 In Transit</div>
        <div className="status-box">📍 Out for Delivery</div>
        <div className="status-box">✅ Delivered</div>
      </div>

      {/* CTA */}
      <div className="tracking-cta" style={{ backgroundImage: `url(${ctaImg})` }}>
        <div className="cta-overlay">
          <h2>Have Questions About Your Shipment?</h2>
          <p>Contact our support team for assistance.</p>
          <button>Get in Touch</button>
        </div>
      </div>
    </div>
  );
};

export default Tracking;
